import { IS_SHOW_COLORS_EDIT_TOOLTIP_LOCALSTORAGE } from '../types';

export const setShowColorsEditTooltipLocalStorage = (
    isShow: boolean
) => {
    localStorage.setItem(IS_SHOW_COLORS_EDIT_TOOLTIP_LOCALSTORAGE, JSON.stringify(isShow));
}
